const paths = [
    {
        path: '/404',
        meta: {
            public: true,
        },
        name: 'NotFound',
        component: () => import(
            `@/pages/NotFound.vue`
        )
    },
    {
        path: '/403',
        meta: {
            public: true,
        },
        name: 'AccessDenied',
        component: () => import(
            `@/pages/Deny.vue`
        )
    },
    {
        path: '/500',
        meta: {
            public: true,
        },
        name: 'ServerError',
        component: () => import(
            `@/pages/Error.vue`
        )
    },
    {
        path: '/login',
        meta: {
            public: true,
        },
        name: 'Login',
        component: () => import(
            `@/pages/Login.vue`
        )
    },
    {
        path: '/novo',
        meta: {
            public: true,
        },
        name: 'NewAffiliate',
        component: () => import(
            `@/pages/NewAffiliate.vue`
        )
    },
    {
        path: '/novo/*',
        meta: {
            public: true,
        },
        name: 'NewAffiliate',
        component: () => import(
            `@/pages/NewAffiliate.vue`
        )
    },
    {
        path: '/',
        meta: { public: true },
        name: 'Root',
        redirect: {
            name: 'Dashboard'
        }
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        props: { obj: 'dashboardCorban' },
        meta: {
            title: 'Dashboard',
            filterComponent: () => import(
                `@/pages/DashboardFilter.vue`
            )
        },
        component: () => import(
            `@/pages/Dashboard.vue`
        )
    },
    {
        path: '/dashboardOld',
        name: 'Dashboard',
        props: { obj: 'dashboardCorban' },
        meta: {
            title: 'Dashboard Antigo',
            filterComponent: () => import(
                `@/pages/DashboardFilter.vue`
            )
        },
        component: () => import(
            `@/pages/DashboardOld.vue`
        )
    },
    {
        path: '/affiliates',
        name: 'Affiliates',
        meta: {
            title: 'Afiliados'
        },
        component: () => import(
            `@/pages/Affiliates.vue`
        )
    },
    {
        path: '/profile',
        name: 'Profile',
        props: { obj: 'affiliate' },
        meta: {
            title: 'Perfil',
        },
        component: () => import(
            `@/pages/Profile.vue`
        )
    },
    {
        path: '/contracts',
        name: 'Contracts',
        meta: {
            title: 'Contratos',
            filterComponent: () => import(
                `@/pages/ContractFilter.vue`
            )
        },
        component: () => import(
            `@/pages/Contracts.vue`
        )
    },
    {
        path: '/production',
        name: 'Production',
        meta: {
            title: 'Produção'
        },
        component: () => import(
            `@/pages/Production.vue`
        )
    },
    {
        path: '/links',
        name: 'Links',
        meta: {
            title: 'Links'
        },
        component: () => import(
            `@/pages/Links.vue`
        )
    },
    {
        path: '/campaigns',
        name: 'Campaigns',
        meta: {
            title: 'Campanhas',
            filterComponent: () => import(
                `@/pages/CampaignFilter.vue`
            )
        },
        component: () => import(
            `@/pages/Campaigns.vue`
        )
    },
    {
        path: '/campaignLeads',
        name: 'CampaignLeads',
        meta: {
            title: 'Produção Por Campanha',
            filterComponent: () => import(
                `@/pages/CampaignLeadsFilter.vue`
            )
        },
        component: () => import(
            `@/pages/CampaignLeads.vue`
        )
    },
    {
        path: '/changepin',
        name: 'ChangePin',
        meta: {
            title: 'Alterar Senha'
        },
        props: {
            newStateTitle: 'Alterar Senha',
            editStateTitle: 'Alterar Senha'
        },
        component: () => import(
            `@/pages/change-pin.vue`
        )
    },
    {
        path: '/wallet',
        name: 'Carteira',
        meta: {
            title: 'Carteira'
        },
        component: () => import(
            `@/pages/Wallet.vue`
        )
    },
    {
        path: '*',
        name: 'any',
        meta: {
            public: true,
        },
        redirect: {
            path: '/404'
        }
    }
];

if(process.env.NODE_ENV != 'production') {
    paths.push({
       path: '/testar',
       name: 'Testar',
       meta: {
          title: 'Testar'
       },
       component: () => import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Testar.vue`
          )
    });
 }

export default paths;
 


// WEBPACK FOOTER //
// ./src/router/paths.js